import { render, staticRenderFns } from "./ModalCadatroProduto.vue?vue&type=template&id=b3a8997e"
import script from "./ModalCadatroProduto.vue?vue&type=script&lang=js"
export * from "./ModalCadatroProduto.vue?vue&type=script&lang=js"
import style0 from "./ModalCadatroProduto.vue?vue&type=style&index=0&id=b3a8997e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports